<template>
  <div id="preview">
    <product :reverse="reverse"></product>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Product from './simulator/preview/Product.vue'
import axios from 'axios/dist/axios.min'

export default {
  name: 'preview',
  components: {
    Product,
  },
  created(){
    axios.get('/carts/' + this.order_number + '.json'
    ).then(response => {
      const json = JSON.parse(response.data.cart.json);
      if (json.json.stock_cart) {
        const cart = json.json.stock_cart[this.$route.params.index - 1];
        this.$store.commit('setCartCategory', cart.category);
        this.$store.commit('setCartFigure', cart.figure);
        this.$store.commit('setCartDesign', cart.design);
        this.$store.commit('setCartParts', cart.parts);
        this.$store.commit('setCartLetters', cart.letters);
      } else {
        this.$store.commit('setCartJson', {
          // number: response.data.cart.code,
          // json: json
          category: json.json.category,
          figure: json.json.figure,
          design: json.json.design,
          parts: json.json.parts,
          letters: json.json.letters,
          packs: json.json.packs,
          number: response.data.cart.code,
          order: json.json.order,
        });
      }
      this.$store.commit('changeActiveTab', 3);
    });
  },
  data () {
    return {
      reverse: (this.$route.params.direction == 'back') ? true : false,
      order_number: this.$route.params.id,
    }
  },
}
</script>

<style>
  #layer_front .picture{
    position: absolute;top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 230px;
    height: 190px;
    /*margin: 0 auto;*/
  }
  #layer_back .picture{
    position: absolute;
    top: 50px;
    left: 2px;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 115px;
    height: 95px;
  }
</style>
